/**
 * Converte un file immagine in una stringa Base64 JPEG usando Canvas.
 * @param {File} file - Il file immagine da convertire.
 * @param {number} quality - La qualità dell'immagine JPEG (da 0 a 1). Default 0.8.
 * @returns {Promise<string>} - Una promessa che risolve con la stringa DataURL dell'immagine.
 */
export const convertToBase64Jpeg = (file, quality = 0.8) => {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error("Nessun file fornito"));
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          if (!ctx) {
            reject(new Error("Impossibile ottenere il contesto 2D del canvas"));
            return;
          }
          ctx.drawImage(img, 0, 0);
          const dataUrl = canvas.toDataURL("image/jpeg", quality);
          resolve(dataUrl);
        } catch (err) {
          reject(err);
        }
      };
      img.onerror = () => reject(new Error("Errore nel caricamento dell'immagine"));
      img.src = e.target.result;
    };
    reader.onerror = () => reject(new Error("Errore nella lettura del file"));
    reader.readAsDataURL(file);
  });
};
 